export default function () {
  const widgetName = 'sponsorWidgetContainer';
  const widgetOpts = sponsorWidgetContainerOpts;

  return saffire.widgets.sponsors($(`#${widgetName}`), {
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    timePerSponsor: 2,
    bw: false,
    rotate: true

    
    
  });

  

}